import clsx from 'clsx';
import React, { useMemo, useState } from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';
import { useTypedDispatch } from '../../Hooks/useTypedDispatch';
import { setLoginFormLoading } from '../../Actions/Login.action';

const LoginTypeSelector = () => {
  const dispatch = useTypedDispatch();
  const {
    isB2b: initialIsB2b,
    b2bUrl,
    b2cUrl,
  } = useTypedSelector((state) => state.login);

  const [isB2b, setIsB2b] = useState<boolean>(initialIsB2b);

  const onLinkClicked = (
    isB2b: boolean,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();

    // As we redirect away from the page, we can set the form to loading
    // without resetting it again. Same goes for IsB2b.
    dispatch(setLoginFormLoading(true));
    setIsB2b(isB2b);
    setTimeout(() => {
      location.href = (e.target as HTMLAnchorElement).href;
    }, 300);
  };

  return (
    <div className="relative mb-6 flex w-full justify-between rounded bg-gray-100 p-0.5">
      <a
        className={clsx(
          'relative z-10 flex flex-1 cursor-pointer items-center justify-center rounded py-3',
          isB2b ? 'text-gray-500' : 'font-bold text-gray-900'
        )}
        href={b2cUrl}
        onClick={(e) =>
          isB2b && !!b2cUrl ? onLinkClicked(false, e) : e.preventDefault()
        }
      >
        {translate('login.private-customer')}
      </a>
      <a
        className={clsx(
          'relative z-10 flex flex-1 cursor-pointer items-center justify-center rounded py-3',
          isB2b ? 'font-bold text-gray-900' : 'text-gray-500'
        )}
        href={b2bUrl}
        onClick={(e) =>
          !isB2b && !!b2bUrl ? onLinkClicked(true, e) : e.preventDefault()
        }
      >
        {translate('login.company-customer')}
      </a>
      <div
        className={clsx(
          'absolute bottom-0.5 top-0.5 w-1/2 rounded bg-white transition-[left] duration-300',
          isB2b ? 'left-[calc(50%_-_2px)]' : 'left-0.5'
        )}
      ></div>
    </div>
  );
};

export default LoginTypeSelector;
